import {
  getSubscriptionState,
  PlanStatus,
} from "@syla/shared/types/helpers/subscriptions";
import { SubscriptionWithPlansAndAccess } from "@syla/shared/types/responses/GetSubscriptionsResponse";

export function getPlanStatus(
  subscription: SubscriptionWithPlansAndAccess<unknown> | undefined,
): PlanStatus {
  if (!subscription) {
    return PlanStatus.None;
  }

  return getSubscriptionState(subscription).planStatus;
}
